class FeatureFlag {
  constructor(args) {
    if (args.default === undefined) {
      throw new TypeError("default must be defined");
    }

    if (typeof args.key !== "string") {
      throw new TypeError("key must be a string");
    }

    this.default = args.default;
    this.key = args.key;
  }
}

export const FeatureFlags = {
  dataRetention: new FeatureFlag({
    key: "data_retention",
    default: 366,
  }),
  detectionFilterManagement: new FeatureFlag({
    key: "detection_filter_management",
    default: false,
  }),
  blumiraAgent: new FeatureFlag({
    key: "blumira_agent",
    default: false,
  }),
};
